module.exports = __webpack_public_path__ + "static/media/adobe-Illustrator-logo.47ae0093.svg";